(function () {
  if (window.PaulJoeFreeGift) return;
  window.PaulJoeFreeGift = true;

  var COLLECTION_PROP = '_collectionFreeGift';
  var PRODUCT_PROP = '_productFreeGift';
  var lastCart = { items: [] };
  var pendingAdds = {};
  var unavailable = {};
  var syncChain = Promise.resolve();

  function cartRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getCart() {
    return fetch(cartRoot() + 'cart.js').then(function (response) {
      return response.json();
    });
  }

  function configEl() {
    return (
      document.querySelector('cart-drawer [data-free-gift-config]') ||
      document.querySelector('[data-free-gift-config]')
    );
  }

  function idList(datasetKey) {
    var el = document.querySelector('[data-free-gift-config]');
    if (!el || !el.dataset[datasetKey]) return [];
    return el.dataset[datasetKey].split(',').filter(Boolean);
  }

  function collectionVariantIds() {
    return idList('giftVariantIds');
  }

  function productVariantIds() {
    return idList('productGiftVariantIds');
  }

  function isCollectionGift(item) {
    return !!(item && item.properties && item.properties[COLLECTION_PROP] === 'true');
  }

  function isProductGift(item) {
    return !!(item && item.properties && item.properties[PRODUCT_PROP] === 'true');
  }

  function isLegacyGift(item) {
    return !!(item && item.properties && item.properties._isGift === 'true');
  }

  function variantInCart(cart, variantId) {
    return (cart.items || []).some(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function rememberCart(cart) {
    lastCart = cart || { items: [] };
    var known = collectionVariantIds().concat(productVariantIds());
    (lastCart.items || []).forEach(function (item) {
      if (isCollectionGift(item) || isProductGift(item) || known.indexOf(String(item.variant_id)) !== -1) {
        pendingAdds[String(item.variant_id)] = true;
      }
    });
  }

  function variantBlocked(variantId) {
    var id = String(variantId);
    if (pendingAdds[id]) return true;
    return variantInCart(lastCart, id);
  }

  function cartHasRtw() {
    var el = configEl();
    return !!(el && el.dataset.hasRtw === 'true');
  }

  function cartHasBeauty() {
    var el = configEl();
    return !!(el && el.dataset.hasBeauty === 'true');
  }

  function bothCollectionsPresent(productRtw, productBeauty) {
    return (cartHasRtw() || !!productRtw) && (cartHasBeauty() || !!productBeauty);
  }

  function cartHasProductEligible() {
    var el = configEl();
    return !!(el && el.dataset.hasProductEligible === 'true');
  }

  function collectionEligible() {
    var el = configEl();
    return !!(el && el.dataset.hasEligible === 'true');
  }

  function toGiftItems(ids, propertyName, skipUnavailable) {
    return ids
      .filter(function (id) {
        if (skipUnavailable && unavailable[String(id)]) return false;
        return !variantBlocked(id);
      })
      .map(function (id) {
        var properties = {};
        properties[propertyName] = 'true';
        return {
          id: Number(id),
          quantity: 1,
          properties: properties
        };
      });
  }

  function itemsToAddFromCache(options) {
    options = options || {};
    var items = [];
    if (bothCollectionsPresent(options.productRtw, options.productBeauty)) {
      items = items.concat(toGiftItems(collectionVariantIds(), COLLECTION_PROP, false));
    }
    if (options.productEligible || cartHasProductEligible()) {
      items = items.concat(toGiftItems(productVariantIds(), PRODUCT_PROP, true));
    }
    return items;
  }

  function markPending(items) {
    (items || []).forEach(function (item) {
      pendingAdds[String(item.id)] = true;
    });
  }

  window.PaulJoeCollectionGifts = {
    itemsToAddFromCache: itemsToAddFromCache,
    markPending: markPending
  };

  function addGifts(variantIds, propertyName, trackUnavailable) {
    variantIds.forEach(function (id) {
      pendingAdds[String(id)] = true;
    });
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: variantIds.map(function (id) {
          var properties = {};
          properties[propertyName] = 'true';
          return {
            id: Number(id),
            quantity: 1,
            properties: properties
          };
        }),
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          variantIds.forEach(function (id) {
            delete pendingAdds[String(id)];
            if (trackUnavailable) unavailable[String(id)] = true;
          });
          if (trackUnavailable) return null;
          throw json;
        }
        return json;
      });
    });
  }

  function changeLine(key, quantity) {
    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function copyFreshSync() {
    var fresh = document.querySelector('cart-drawer [data-free-gift-config]');
    if (!fresh) return;
    document.querySelectorAll('[data-free-gift-config]').forEach(function (el) {
      el.dataset.hasRtw = fresh.dataset.hasRtw;
      el.dataset.hasBeauty = fresh.dataset.hasBeauty;
      el.dataset.hasEligible = fresh.dataset.hasEligible;
      el.dataset.hasProductEligible = fresh.dataset.hasProductEligible;
      el.dataset.giftVariantIds = fresh.dataset.giftVariantIds;
      el.dataset.productGiftVariantIds = fresh.dataset.productGiftVariantIds;
      el.dataset.cartOnlyGifts = fresh.dataset.cartOnlyGifts;
    });
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.dataset.sectionId) {
      if (typeof renderIconBubble === 'function') renderIconBubble();
      document.dispatchEvent(new CustomEvent('jc-cart:reload'));
      return Promise.resolve();
    }

    return fetch(cartRoot() + '?sections=' + drawer.dataset.sectionId)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data[drawer.dataset.sectionId];
        var cartDom = new DOMParser().parseFromString(html, 'text/html');
        var nextInner = cartDom.querySelector('.drawer__inner');
        var currentInner = document.querySelector('.drawer__inner');
        if (nextInner && currentInner) {
          currentInner.innerHTML = nextInner.innerHTML;
        }
        drawer.classList.remove('is-empty');
        copyFreshSync();
        if (typeof renderIconBubble === 'function') renderIconBubble();
        document.dispatchEvent(new CustomEvent('jc-cart:reload'));
      });
  }

  function capLines(lines, chainState) {
    var seen = {};
    lines.forEach(function (gift) {
      var id = String(gift.variant_id);
      if (seen[id]) {
        chainState.chain = chainState.chain.then(function () {
          return changeLine(gift.key, 0);
        });
        chainState.changed = true;
        return;
      }
      seen[id] = true;
      if (gift.quantity > 1) {
        chainState.chain = chainState.chain.then(function () {
          return changeLine(gift.key, 1);
        });
        chainState.changed = true;
      }
    });
  }

  function removeLines(lines, chainState) {
    lines.forEach(function (gift) {
      chainState.chain = chainState.chain.then(function () {
        delete pendingAdds[String(gift.variant_id)];
        return changeLine(gift.key, 0);
      });
      chainState.changed = true;
    });
  }

  function runSync() {
    return getCart().then(function (cart) {
      rememberCart(cart);
      var chainState = { chain: Promise.resolve(), changed: false };
      var collectionGifts = (cart.items || []).filter(isCollectionGift);
      var legacyGifts = (cart.items || []).filter(isLegacyGift);
      var productGifts = (cart.items || []).filter(isProductGift);

      capLines(collectionGifts.concat(legacyGifts), chainState);
      capLines(productGifts, chainState);

      if (!collectionEligible()) {
        removeLines(collectionGifts.concat(legacyGifts), chainState);
      } else {
        var missingCollection = collectionVariantIds().filter(function (id) {
          return !variantInCart(cart, id);
        });
        if (missingCollection.length) {
          chainState.chain = chainState.chain.then(function () {
            return addGifts(missingCollection, COLLECTION_PROP, false);
          });
          chainState.changed = true;
        }
      }

      if (!cartHasProductEligible()) {
        removeLines(productGifts, chainState);
      } else {
        var missingProduct = productVariantIds().filter(function (id) {
          return !unavailable[String(id)] && !variantInCart(cart, id);
        });
        if (missingProduct.length) {
          chainState.chain = chainState.chain.then(function () {
            return addGifts(missingProduct, PRODUCT_PROP, true);
          });
          chainState.changed = true;
        }
      }

      return chainState.chain.then(function () {
        if (!chainState.changed) return null;
        if (document.querySelector('.cart [js-cart]')) {
          window.location.reload();
          return;
        }
        return refreshDrawer();
      });
    });
  }

  function syncGifts() {
    syncChain = syncChain.then(runSync, runSync);
    return syncChain;
  }

  function blockGiftOnlyCheckout(event) {
    var config = configEl();
    if (config && config.dataset.cartOnlyGifts === 'true') {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
    var checkout = event.target.closest('#CartDrawer-Checkout, [name="checkout"]');
    if (checkout && checkout.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
    return false;
  }

  document.addEventListener('jc-cart:reload', function () {
    copyFreshSync();
    syncGifts();
  });

  document.addEventListener(
    'click',
    function (event) {
      var checkout = event.target.closest('#CartDrawer-Checkout, [name="checkout"]');
      if (!checkout) return;
      blockGiftOnlyCheckout(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      blockGiftOnlyCheckout(event);
    },
    true
  );

  function init() {
    getCart().then(function (cart) {
      rememberCart(cart);
      syncGifts();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
